import React, { useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import TabsComponent from "../../components/helper-components/tabs-component";
import BulkPurchaseOrder from "./bulk-purchase-order";
import BulkPurchaseReturn from "./bulk-purchase-return";

const ITEM_TABS = ["PO", "PR"];

const TITLES = {
  PO: "Bulk Purchase Order",
  PR: "Bulk Purchase Return",
};

const BulkPurchaseWorkspace = () => {
  // The sidebar's "Bulk Purchase" entry only routes to
  // /bulk-purchase-transactions — there's no separate PO/PR route — so this
  // workspace always opens on PO; PR is reached by switching tabs.
  const [currentTab, setCurrentTab] = useState("PO");

  return (
    <InnerLayout module="purchase_order" title={TITLES[currentTab]} backBtn={true}>
      <div className="h-full flex flex-col">
        <div className="px-2">
          <TabsComponent
            itemTabs={ITEM_TABS}
            currentTab={currentTab}
            handleClickfn={(tab) => setCurrentTab(tab)}
          />
        </div>
        <div className="flex-1 min-h-0">
          {currentTab === "PO" && <BulkPurchaseOrder />}
          {currentTab === "PR" && <BulkPurchaseReturn />}
        </div>
      </div>
    </InnerLayout>
  );
};

export default BulkPurchaseWorkspace;
